import {NgModule} from '@angular/core';
import {OffersRoutingModule} from './offers-routing.module';
import {OffersComponent} from './offers.component';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {CreateOfferComponent} from './create-offer/create-offer.component';
import {NgSelect2Module} from 'ng-select2';
import {EditOfferComponent} from './edit-offer/edit-offer.component';
import {ListOfferComponent} from './list-offer/list-offer.component';
import {ViewOfferComponent} from './view-offer/view-offer.component';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {SharedModuleModule} from '../../../shared-module/shared-module.module';
import {NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';


@NgModule({
    declarations: [OffersComponent, CreateOfferComponent, EditOfferComponent, ListOfferComponent, ViewOfferComponent],
    imports: [
        CommonModule,
        FormsModule,
        OffersRoutingModule,
        NgSelect2Module,
        MatSnackBarModule,
        SharedModuleModule,
        NgbPaginationModule
    ]
})

export class OffersModule {
}
